The name of the advertisement product for displaying to the user.

This is typically a single word that differentiates the product from other options.
